import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {InformationService} from "../../services/information.service";
import {Subject, takeUntil} from "rxjs";
import {environment} from "../../../environments/environment";
import {PaymentComponent} from "../payment/payment.component";
import {LibraryService} from "../../services/library.service";
import {LibrarySubscription} from "../../model/library";

@Component({
  selector: 'library-subscription',
  templateUrl: './library-subscription.component.html',
  styleUrls: ['./library-subscription.component.less']
})
export class LibrarySubscriptionComponent implements OnInit, OnDestroy{

  email: string;
  name: string;
  noValidEmail: boolean = false;
  noName: boolean = false;
  resultCheck: boolean = false;
  check: boolean = false;
  librarySubscription: LibrarySubscription;
  unSubscriptionError: string;
  unSubscriptionResult: string;

  @ViewChild('paymentComponent')
  paymentComponent: PaymentComponent;

  private destroySubject: Subject<void> = new Subject();

  selectedTab: number = 0;

  constructor(
    public libraryService: LibraryService,
  ) {}

  ngOnInit(): void {
  }

  subscribe() {
    this.noValidEmail = false;
    this.noName = false;

    if (!this.isValidEmail(this.email)) {
      this.noValidEmail = true;
      return
    }
    if (!this.name) {
      this.noName = true;
      return
    }
    let params: any = {}
    let  url = environment.dns + "library";
    params.success_url = url;
    params.cancel_url = url;
    params.email = this.email;
    params.name = this.name;

    this.paymentComponent.subscriptionCheckout(params);

  }

  unSubscribe() {
    this.noValidEmail = false;
    this.unSubscriptionError = '';
    this.unSubscriptionResult = '';

    if (!this.isValidEmail(this.email)) {
      this.noValidEmail = true;
      return
    }

    this.libraryService.unsubscribeLibrary(this.email).subscribe((resp) =>{
      this.unSubscriptionResult = 'Вы успешно отписались от подписки';
      this.email = '';
    },
      error => {
      console.log(error)
        if(error.status == 404){
          this.unSubscriptionError = 'Подписка не найдена, проперьте правильность ввода email'
        }
      })
  }

  checkSubscription() {
    this.check = false;
    this.resultCheck = false;
    this.noValidEmail = false;

    if (!this.isValidEmail(this.email)) {
      this.noValidEmail = true;
    } else {
      this.libraryService.checkLibrarySubscription(this.email).subscribe((result) => {
        this.check = true;
        if (!result.subscriptions?.length) {
          this.resultCheck = false;
        } else {
          this.resultCheck = true;

          this.librarySubscription =  result.subscriptions[0];
          console.log(this.librarySubscription)


        }
      })
    }


  }


  ngOnDestroy() {
    this.destroySubject.next();
  }

  isValidEmail(email: string): boolean {
    this.email = this.email.trim()
    const emailRegex = "^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$"
    let isValid = true;

    if (!this.email?.match(emailRegex)) {
      isValid = false;
    }
    return isValid;
  }


}




